// message.js
import Vue from 'vue'
import MessageComponent from '../components/Message.vue'

const Message = (options = {}) => {
  // 支持传入字符串或对象
  const opts = typeof options === 'string' ? { message: options } : options

  // 创建实例
  const instance = new Vue({
    render: (h) => h(MessageComponent, {
      props: {
        message: opts.message,
        type: opts.type || 'info',
        duration: opts.duration != null ? opts.duration : 3000,
        showClose: opts.showClose != null ? opts.showClose : false,
        showIcon: opts.showIcon != null ? opts.showIcon : true,
        customClass: opts.customClass || '',
        onClose: opts.onClose || null
      }
    })
  }).$mount()

  // 获取组件实例
  const component = instance.$children[0]
  component.visible = true

  // 返回实例以便手动关闭
  return component
}

// 快捷方法
Message.success = (msg, opts = {}) => Message({ ...opts, message: msg, type: 'success' })
Message.warning = (msg, opts = {}) => Message({ ...opts, message: msg, type: 'warning' })
Message.error = (msg, opts = {}) => Message({ ...opts, message: msg, type: 'error' })
Message.info = (msg, opts = {}) => Message({ ...opts, message: msg, type: 'info' })

export default Message



// WEBPACK FOOTER //
// ./src/utils/message.js